var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgM26(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_5440_45571",
    transform: "scale(0.0208333)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_5440_45571",
    width: 48,
    height: 48,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAACXBIWXMAAAsTAAALEwEAmpwYAAACGElEQVRo3u2aPU/CUBSGWZzsyJ/wAwGj1I9FZ4noQqIDbjoa2CWCoBETNuMf0MGF1QCKn3EgaXBzACdGXV3E5HpO0pZ6U+FCaOlpPMmbEIZz3qftvbfn3no8/9GOueOKNJkuyROp0iYoAb+TT42PPcbYLigKmgGNOsbw6cObJ5ApT4PRw/FUURnbL36DmFEAwLhogaqgLCgAst84FB3ZPle2wPgLb1gAgI8aKIY57TCOioDq2atX1s28IIAWdTW3Zea9oIJWzQIALbCGd9DmQ6CmsYqFAEytJQ/KfBj0yVewGICpNcODMP9llt0GAKbWDvdrXja78jYDaHdC7mfANjtltRFAGxPeXqbKQreMNgNos5MQQEQk2xAAMCJdV1h1QXEqQL3jiq0u6czBABixTs9+jQBAzXQswJ/+XrIMEQDDbwaQIQSQMQOoEgKo/jK/lL+T5nOV1kKuwkQFjYwQwOzRDeslr4jQ6/rZc7uzmzooyyJmnKRg9jqkA2APSw3Aly5tGAES1ACgnY3rALh7QBAg6SqAODUAfOx1ABwQ5O4ATDw6AE5J1ABw6tcB1mBRoLaQLefvJfe8SrjlZY786zTthoZ8S+mKpp78toorNrbIby1yZwI0N3cNECtkt9c5CJoHHK44YnLFIR83xa6SPGblV+ydCyVG7qCbj0ulid1c0EftU4O/YvHkVvJxH3s8Nt6d+7GHE+IH73vkL0baJE8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgM26);
export default __webpack_public_path__ + "static/media/m26.9c0f7cc58e07b5320b2e8348144dd650.svg";
export { ForwardRef as ReactComponent };